import { getQuery } from "./PaymentgatewayWrapper.js";

export const getRemainingActiveFlowsAndExecution = async (tenant_id) => {
  try {
    const data = JSON.stringify({
      query: `query GetActiveFlowsAndExecution($tenantId: String!) {
  getActiveFlowsAndExecution(tenant_id: $tenantId) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: {
        tenantId: tenant_id,
      },
    });
    const response = await getQuery(data);
    return response?.getActiveFlowsAndExecution;
  } catch (error) {
    console.log(error);
  }
};
